import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from './config'
import { shargoRef } from './firebase'
import { orderBy } from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: true,
    info: null,
    error: null,
    profile: {},
    catalog: [],
    catalog_categories: [],
    catalog_products: [],
    sendPrice: 0,
    sendLink: null,
    showConditions: false
  },
  getters: {
    totalPedido(state) {
      let total = 0
      const order = Object.values(state.profile.order || [])
      order.forEach(p => {
        const uds = Number(p.UDS)
        let pvp = p.PVP
        const format = p.FORMAT
        if (format && Number(format.PVP) > 0) pvp = Number(format.PVP)
        total += Number(pvp) * uds
        if (p.EXTRAS)
          p.EXTRAS.forEach(e => {
            if (e.extras)
              e.options.forEach(o => {
                total += o.INCPRECIO || 0
              })
          })
      })
      /** check online api for price */
      const location = state.profile.order_location
      if (location && location.address && location.destination) {
        this.$store
          .dispatch('getSendPrice')
          .then(result => {
            this.totalSendPrice = Number(result).toFixed(2)
          })
          .catch(error => {
            state.error(error.message)
          })
      }

      return total.toFixed(2)
    },
    uid(state) {
      if (!state.profile || !state.profile.user) return null
      return state.profile.user && state.profile.user.uid
    },
    user(state) {
      if (!state.profile || !state.profile.user) return null
      return state.profile.user
    },
    order(state) {
      if (!state.profile || !state.profile.user) return null
      return state.profile.order
    },
    order_location(state) {
      if (!state.profile || !state.profile.user) return null
      return state.profile.order_location
    },
    catalog_favoritos(state) {
      return state.catalog.FAVORITOS
    },
    catalog_articulos(state) {
      return state.catalog.ARTICULOS
    },
    catalog_formatos(state) {
      return state.catalog.FORMATOS
    },
    catalog_modificadores(state) {
      return state.catalog.MODIFICADORES
    },
    catalog_opciones(state) {
      return state.catalog.OPCIONES
    }
  },
  mutations: {
    showConditions(state, value = true) {
      state.showConditions = value
    },
    isLoading(state, isLoading) {
      state.loading = isLoading
    },
    setInfo(state, info) {
      state.loading = false
      state.info = info
    },
    setSendLink(state, link) {
      state.loading = false
      state.sendLink = link
    },
    setError(state, error) {
      state.loading = false
      state.error = error
    },
    setUserProfile(state, userData) {
      state.loading = false
      state.profile = userData
    },
    setLocation(state, order_location) {
      state.profile.order_location = order_location
    },
    setOrder(state, order) {
      state.order = order
    },
    setSendPrice(state, price) {
      state.sendPrice = price
    },
    setCatalog(state, catalog) {
      state.catalog = catalog
    },
    setCatalogCategories(state, categories) {
      state.catalog_categories = categories
    },
    setCatalogProducts(state, products) {
      state.catalog_products = products
    }
  },
  actions: {
    getPaymentData({ commit }, data) {
      const { user, total, orderId } = data
      return axios
        .post(
          'https://us-central1-imm-delivery.cloudfunctions.net/payment/data/',
          {
            user,
            amount: total,
            order: orderId
          }
        )
        .then(result => {
          return result.data
        })
        .catch(error => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message &&
            error.response.data.errorCode === 'NF005'
          )
            commit(
              'setError',
              'AHORA MISMO NO PROPORCIONAMOS SERVICIO EN ESTA ZONA'
            )
          else if (error.response.data && error.response.data.message)
            commit('setError', error.response.data.message)
          else commit('setError', error.message)
        })
    },
    getSendPrice({ commit, state }) {
      return 0
      const location = state.profile.order_location
      if (
        !location ||
        !location.address ||
        !location.destination.lat ||
        !location.destination.lng
      ) {
        return 0
      }

      const data = {
        transport: 1,
        originAddress: 'Vía Augusta, 105, Ibiza',
        originLatitude: 41.401069,
        originLongitude: 2.148427,
        destinationAddress: location.address,
        destinationLatitude: location.destination.lat,
        destinationLongitude: location.destination.lng,
        numItems: Object.values(state.profile.order || ['']).length
      }
      return axios
        .post(`${config.baseApiUrl}prices`, data, {
          headers: config.headers
        })
        .then(async result => {
          const precioEnvio =
            (result &&
              result.data &&
              result.data.price &&
              result.data.price.amount) ||
            0
          const snap = await shargoRef.once('value')
          const data = snap.val()
          let escalados = []
          Object.keys(data).forEach(importe => {
            const porcentaje = data[importe]
            escalados.push({
              importe: Number(importe),
              porcentaje: Number(porcentaje)
            })
          })
          console.log(escalados)
          let total = 0
          const order = Object.values(state.profile.order || [])
          order.forEach(p => {
            const uds = Number(p.UDS)
            let pvp = p.PVP
            const format = p.FORMAT
            if (format && Number(format.PVP) > 0) pvp = Number(format.PVP)
            total += Number(pvp) * uds
            if (p.EXTRAS)
              p.EXTRAS.forEach(e => {
                if (e.extras)
                  e.options.forEach(o => {
                    total += o.INCPRECIO || 0
                  })
              })
          })
          console.log('ENVIO:', precioEnvio)
          console.log('PVP PEDIDO:', total)
          let escalado
          escalados = orderBy(escalados, 'importe')
          escalados.forEach(e => {
            if (total > e.importe) escalado = e
            else return
          })
          console.log('ESCALADO:', escalado)
          return escalado && escalado.porcentaje
            ? (precioEnvio * escalado.porcentaje) / 100
            : precioEnvio
        })
        .catch(error => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message &&
            error.response.data.errorCode === 'NF005'
          ) {
            commit(
              'setError',
              'AHORA MISMO NO PROPORCIONAMOS SERVICIO EN ESTA ZONA'
            )
          } else if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            commit('setError', '___' + error.response.data.message)
          } else {
            commit('setError', '' + error.message)
          }
          //return -1
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js